import { OnInit, Directive } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { UserActionBaseComponent } from '../userAction-base.component';
import { KeyValueItem } from '../../../../Model/System/KeyValueItem';
import { ValidFeatureSystem } from '../../../../Model/ValidFeatureSystem';
import { ValidFeatureService } from '../../../../Services/validFeature.service';
import { lastValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';

@Directive()
export abstract class UserActionFeatureSystemsComponent extends UserActionBaseComponent implements OnInit {
  featureSystems: ValidFeatureSystem[] = [];
  featureSystemsLoaded = false;
  featureSystemsLoading = false;
  isLoading = false;
  systemsFromTemplate: KeyValueItem[];

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public catalogService: CatalogService,
    public validFeatureService: ValidFeatureService
  ) {
    super(loginService, macroService);
  }

  async ngOnInit() {
    super.ngOnInit();
    await this.loadFeatureSystems();
  }

  async loadFeatureSystems() {
    if (!this.featureSystemsLoaded) {
      this.featureSystemsLoading = true;

      if(!this.macroService.workflowMode){
        this.featureSystems = await lastValueFrom(
          this.validFeatureService.getCatalogSystems(
            this.catalogService.selectedCatalogId,
            this.loginService.currentUser.customerId
          )
        );
      }
      else{
        this.featureSystems = await lastValueFrom(
          this.validFeatureService.getSystems(
            this.loginService.currentUser.customerId
          )
        );
      }
      
      if(!this.macroService.workflowMode){
        var categoryFeatureSystems = await lastValueFrom(this.validFeatureService.getCategorySystems(this.catalogService.selectedCatalogId, this.loginService.currentUser.customerId));
        const existingIds = new Set(this.featureSystems.map(x => x.id));
        var relevantCategoryFeatureSystems = categoryFeatureSystems.filter(fs => !existingIds.has(fs.id));
        this.featureSystems.push(...relevantCategoryFeatureSystems);
      }

      this.featureSystemsLoading = false;
      this.featureSystemsLoaded = true;
    }
  }

  async loadFeatures(featureSystem: ValidFeatureSystem) {
    this.featureSystemsLoading = true;

    let features = await lastValueFrom(
      this.validFeatureService.getCatalogFeaturesOfSystem(
        this.catalogService.selectedCatalogId,
        this.loginService.currentUser.customerId,
        featureSystem
      )
    );
    const unique = [...new Map(features.map(f => [f.id, f])).values()];
    this.featureSystemsLoading = false;
    return unique;
  }


}
